"use client";

import { useMediaQuery } from "usehooks-ts";

import { css } from "@/../styled-system/css";
import CancelFill from "@/assets/svg/cancel-fill.svg";
import CheckFill from "@/assets/svg/check-fill.svg";
import InfoFill from "@/assets/svg/info-fill.svg";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/Toast";
import { useToast } from "@/components/ui/UseToast";

function switchIcon(
  variant: "default" | "warning" | "destructive" | undefined,
) {
  switch (variant) {
    case "warning":
      return <InfoFill fill="#FFD21E" width="1.25rem" />;
    case "destructive":
      return <CancelFill fill="#F04248" width="1.25rem" />;
    default:
      return <CheckFill fill="#41C8E6" width="1.25rem" />;
  }
}

export function Toaster() {
  const desktop = useMediaQuery("(min-width: 62rem)");
  const { toasts } = useToast();

  return (
    <ToastProvider swipeDirection={desktop ? "right" : "up"}>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div
              className={css({
                display: "flex",
                gap: "4",
                width: "100%",
              })}
            >
              <div
                className={css({
                  p: "1.5",
                  rounded: "full",
                  backgroundColor: "brandBlueCharcoal/70",
                  height: "fit",
                })}
              >
                {switchIcon(props.variant)}
              </div>
              <div>
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
